<template>
  <el-menu class="navbar"
           mode="horizontal">
    <div class="right-menu">
      <div class="user-depart"
           @click="goDetails">
        <!-- <svg-icon icon-class="home"></svg-icon> -->
        <span>{{company_name}}</span>
      </div>
      <el-dropdown class="avatar-container right-menu-item"
                   trigger="click">
        <div class="avatar-wrapper">
          <div class="user-avatar">
            <p>{{user_name}}</p>
            <p>{{user_phone}}</p>
          </div>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="logout">
              退出登录
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>
</template>

<script>
export default {
  data () {
    return {
      company_name: '',
      user_name: '',
      user_phone: ''
    }
  },
  created () {
    this.company_name = localStorage.getItem('company_name')
      ? localStorage.getItem('company_name')
      : ''
    this.user_name = localStorage.getItem('name')
      ? localStorage.getItem('name')
      : ''
    this.user_phone = localStorage.getItem('phone')
      ? localStorage.getItem('phone')
      : ''
  },
  methods: {
    toggleSideBar () {
      this.$emit('toggleSideBar')
    },
    logout () {
      localStorage.clear();
      this.$router.push('/login')
    },
    goDetails () {
         if (localStorage.getItem("isAdmin") != "true") {
           this.$router.push({ path: "/home/administrators/details", query: { id: localStorage.getItem("company_id")} });
         }
    }
  }
}

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 66px;
  line-height: 66px;
  background-color: #323944;
  height: 66px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 74px;
    height: 66px;
    float: left;
    padding: 0 10px;
    &:hover {
      fill: #bec8d4;
    }
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    .el-dropdown-link {
      cursor: pointer;
    }
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
      height: 20px;
    }
    .international {
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .user-depart {
      float: left;
      color: #bec8d4;
      margin-right: 50px;
    }
    .avatar-container {
      height: 66px;
      margin-right: 30px;
      border-left: 1px solid #666666;
      .avatar-wrapper {
        cursor: pointer;
        position: relative;
        .user-avatar {
          width: 100px;
          border-radius: 10px;
          margin-top: 20px;
          p {
            line-height: 5px;
            color: #bec8d4;
          }
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -10px;
          top: 5px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
